export const buildTemplateComposerUpdate = ({
  templateId,
  template,
  currentSubject = '',
  currentBody = '',
  subjectReadOnly = false,
  preserveSubjectOnTemplateChange = false,
}) => ({
  templateId,
  subject: subjectReadOnly || preserveSubjectOnTemplateChange
    ? currentSubject
    : (template?.subjectHtml || currentSubject),
  body: template?.bodyHtml || currentBody,
});
